(() => {
  if (window.cafeblowFreeShippingStarted) return;
  window.cafeblowFreeShippingStarted = true;

  let timer;
  let controller;
  let version = 0;

  const root = () => window.Shopify?.routes?.root || '/';
  const isCartPage = () => location.pathname.replace(/\/$/, '') === `${root()}cart`.replace(/\/$/, '');
  const goal = (element) => {
    const amount = Number(element.dataset.goalAmount);
    return Number.isFinite(amount) && amount > 0 ? amount : 5000;
  };
  const replaceHTML = (element, html) => {
    if (element && element.innerHTML !== html) element.innerHTML = html;
  };

  function clearMessages() {
    replaceHTML(document.querySelector('#free-shipping-topbar .free-shipping-topbar__text'), '');
    replaceHTML(document.getElementById('free-shipping-wrapper'), '');
  }

  function render(cart) {
    if (cart.currency !== 'JPY' || !Number.isFinite(cart.total_price)) {
      clearMessages();
      return;
    }

    const total = cart.total_price / 100;
    const topbar = document.getElementById('free-shipping-topbar');
    if (topbar) {
      const hidden = topbar.dataset.showOnCart === 'false' && isCartPage();
      topbar.classList.toggle('is-hidden', hidden);
      if (!hidden) {
        const remaining = Math.max(0, goal(topbar) - total);
        const html = remaining === 0
          ? '🎉 送料無料です 🎉'
          : `あと <strong>${remaining.toLocaleString('ja-JP')}円</strong> で送料無料です！ `;
        replaceHTML(topbar.querySelector('.free-shipping-topbar__text'), html);
      }
    }

    const wrapper = document.getElementById('free-shipping-wrapper');
    if (wrapper && isCartPage()) {
      const remaining = Math.max(0, goal(wrapper) - total);
      const html = remaining === 0
        ? '<div class="free-shipping-message" style="text-align:right;padding-top:12px;color:#cc0000;font-weight:bold;">🎉 送料無料です！</div>'
        : `<div class="free-shipping-message" style="text-align:right;padding-top:12px;color:#cc0000;">🚚 あと <strong>${remaining.toLocaleString('ja-JP')}円</strong> で送料無料です！<br><a class="free-shipping-link" style="color:#000">&gt;商品の追加はこちら</a></div>`;
      const desired = document.createElement('div');
      desired.innerHTML = html;
      desired.querySelector('.free-shipping-link')?.setAttribute('href', `${root()}collections/all`);
      replaceHTML(wrapper, desired.innerHTML);
    }
  }

  async function update(requestVersion) {
    if (!document.getElementById('free-shipping-topbar') && !document.getElementById('free-shipping-wrapper')) return;
    const currentController = new AbortController();
    controller = currentController;
    const timeout = setTimeout(() => currentController.abort(), 8000);
    try {
      const response = await fetch(`${root()}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: currentController.signal,
      });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await response.json();
      if (requestVersion === version) render(cart);
    } catch (_) {
      if (requestVersion === version) clearMessages();
    } finally {
      clearTimeout(timeout);
      if (controller === currentController) controller = null;
    }
  }

  function schedule() {
    version += 1;
    const requestVersion = version;
    clearTimeout(timer);
    controller?.abort();
    timer = setTimeout(() => update(requestVersion), 120);
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('cafeblow:cart-refresh', schedule);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) schedule();
    });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
